import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { Tooltip } from '@mui/material'
import SmsOutlinedIcon from '@mui/icons-material/SmsOutlined'
import MailOutlineIcon from '@mui/icons-material/MailOutline'
import styled from 'styled-components'
import { selectSchoolSubjects } from 'modules/settings/ducks/selectors'
import { selectTeachersList } from 'modules/teachers/ducks/selectors'
import { buildShortMessageForStudent, buildLongMessageForStudent } from 'modules/newStudents/utils/messageTemplates'
import { copyToClipboard } from 'utils/date'

const MessageForStudentButtons = ({ student }) => {
  const schoolSubjects = useSelector(selectSchoolSubjects)
  const teachersList = useSelector(selectTeachersList)

  const { message, messageLong } = useMemo(() => ({
    message: buildShortMessageForStudent(student, schoolSubjects, teachersList),
    messageLong: buildLongMessageForStudent(student, schoolSubjects, teachersList)
  }), [student, schoolSubjects, teachersList])

  const handleCopyShort = e => {
    e.stopPropagation()
    copyToClipboard(message)()
  }

  const handleCopyLong = e => {
    e.stopPropagation()
    copyToClipboard(messageLong)()
  }

  return (
    <Wrapper onClick={e => e.stopPropagation()}>
      <Tooltip title='Wiadomość krótka (skopiuj)'>
        <IconButton onClick={handleCopyShort}>
          <SmsOutlinedIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title='Wiadomość długa (skopiuj)'>
        <IconButton onClick={handleCopyLong}>
          <MailOutlineIcon />
        </IconButton>
      </Tooltip>
    </Wrapper>
  )
}

export default MessageForStudentButtons

const Wrapper = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
`

const IconButton = styled.span`
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  padding: 4px;
  color: ${({ theme }) => theme.colors.darkGrey};

  &:hover {
    color: ${({ theme }) => theme.colors.secondary.main};
  }
`
